import { render } from "./langueButton.vue?vue&type=template&id=3b8a18c4&scoped=true"
import script from "./langueButton.vue?vue&type=script&lang=js"
export * from "./langueButton.vue?vue&type=script&lang=js"

import "./langueButton.vue?vue&type=style&index=0&id=3b8a18c4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b8a18c4"]])

export default __exports__